import { Flex, Icon, Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

import { useApp } from '@/v2/contexts/app';
import getPointsEarnText from '@/v2/utils/getPointsEarnText';

const EarnPoints = () => {
  const { pointsPerDollar } = useApp() || {};

  return (
    <Skeleton width="225px" height="2.625rem">
      {pointsPerDollar != undefined ? (
        <Flex gap="3">
          <Icon color="brand.primary" name="roo" />
          <Flex flexDirection="column">
            <Text lineHeight="1.5" fontSize="sm">
              {getPointsEarnText(pointsPerDollar, { firstMention: true })}^
            </Text>
            <Text lineHeight="1.5" fontSize="0.75rem" color="greys.steel">
              Plus Status Credits and points on flights
            </Text>
          </Flex>
        </Flex>
      ) : null}
    </Skeleton>
  );
};

export default EarnPoints;
